import jwtAuthAxios from "./auth/jwtAuth";

// El Pulso: uso y errores de los clientes. Ver hermes-backend app/controllers/api/v1/pulse_controller.rb.
const pulseServices = {};

const query = (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value) !== "") search.set(key, String(value));
    });
    const text = search.toString();
    return text ? `?${text}` : "";
};

pulseServices.overview = async (params) => (await jwtAuthAxios.get(`/pulse/overview${query(params)}`)).data;
pulseServices.feed = async (params) => (await jwtAuthAxios.get(`/pulse/feed${query(params)}`)).data.data;
pulseServices.online = async (params) => (await jwtAuthAxios.get(`/pulse/online${query(params)}`)).data.data;
pulseServices.errors = async (params) => (await jwtAuthAxios.get(`/pulse/errors${query(params)}`)).data.data;
pulseServices.errorDetail = async (fingerprint) => (await jwtAuthAxios.get(`/pulse/errors/${encodeURIComponent(fingerprint)}`)).data.data;
pulseServices.health = async (params) => (await jwtAuthAxios.get(`/pulse/health${query(params)}`)).data.data;
pulseServices.usage = async (params) => (await jwtAuthAxios.get(`/pulse/usage${query(params)}`)).data;
pulseServices.licenses = async (params) => (await jwtAuthAxios.get(`/pulse/licenses${query(params)}`)).data.data;
// Con `enforced` (si el bloqueo esta activado) y `holgura_dias`.
pulseServices.licensesReport = async (params) => (await jwtAuthAxios.get(`/pulse/licenses${query(params)}`)).data;
pulseServices.updateLicenses = async (companyId, driverLicenses) =>
    (await jwtAuthAxios.patch(`/pulse/licenses/${companyId}`, { driver_licenses: driverLicenses })).data;

export default pulseServices;
